import React, { useContext, useState } from 'react'
import styles from './TearForm.module.scss'
import { LanguageContext } from '../../context'
import { TRANSLATIONS } from '../../misc/translations.js'
import cn from 'classnames'
import { Controller, useForm, useFormState } from 'react-hook-form'
import fetch from 'isomorphic-fetch'
import { navigate } from 'gatsby'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/pro-solid-svg-icons'

const TearForm = () => {
  const { currentLang: language } = useContext(LanguageContext)
  const t = TRANSLATIONS.hasOwnProperty(language) && TRANSLATIONS[language]
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState()

  const { register, handleSubmit, control, formState: { errors } } = useForm({
    mode: 'onTouched',
  })

  const { dirtyFields } = useFormState({
    control
  })

  const required = {
    value: true,
    message: t.emptyInputError
  }

  const setFocus = id => {
    document.getElementById(id).focus()
  }

  const onSubmit = async data => {
    if (submitting) return
    setSubmitting(true)

    const structuredData = {
      isAdfRequest: false,
      requestFieldValues: {
        description: data.description,
        customfield_10201: data.name,
        customfield_10199: data.phone_number,
        customfield_10200: data.address,
        customfield_10191: Number(data.postcode),
        customfield_10307: data.contractor_name,
      },
      requestTypeId: 468,
      serviceDeskId: 9,
    }

    const imageFile = data.image
    // eslint-disable-next-line no-undef
    const imageFormData = new FormData()
    imageFormData.append('file', imageFile)

    try {
      const response = await fetch('/api/wp-json/kosmos/v1/jira-connection', {
        method: 'POST',
        body: JSON.stringify(structuredData),
      })
      const result = await response.json()
      const issueKey = result?.issueKey

      if (imageFile) {
        const imageResponse = await fetch('/api/wp-json/kosmos/v1/jira-connection-image', {
          method: 'POST',
          body: imageFormData,
        })
        const imageResult = await imageResponse.json()

        const temporaryAttachmentId = imageResult?.temporaryAttachments?.[0].temporaryAttachmentId

        const structuredImageData = {
          public: true,
          temporaryAttachmentIds: [temporaryAttachmentId],
        }

        await fetch(`/api/wp-json/kosmos/v1/jira-connection-attach/${issueKey}`, {
          method: 'POST',
          body: JSON.stringify(structuredImageData),
        })
          .catch(setError)
      }
    } catch (error) {
      console.error('Error: ', error)
      setError(error)
    } finally {
      setSubmitting(false)
      navigate('/takk-fyrir')
    }
  }

  const Error = ({ error, message = t.emptyInputError }) => {
    return Boolean(error && error.message) && (
      <p className={cn('pl-1', styles.error)}>{message}</p>
    )
  }

  const [selectedFile, setSelectedFile] = useState('')

  return (
    <section className='container pb-5 pt-4 mt-3'>
      <form className='row form-styler' onSubmit={handleSubmit(onSubmit)}>
        <div className='col-lg-8 pl-4 ml-1'>
          <div className='row'>
            <div className='col-lg-6'>
              <div className='form-styler form-styler__wrapper'>
                <input
                  {...register('name', { required })}
                  id='name'
                  name='name'
                  type='text'
                />
                <label
                  onClick={() => setFocus('name')}
                  className={cn(
                    { 'label--top': dirtyFields.name }
                  )}>
                  {t.name}*
                </label>
              </div>
              <Error error={errors.name} />
            </div>

            <div className='col-lg-6'>
              <div className='form-styler form-styler__wrapper'>
                <input
                  {...register('phone_number', { required })}
                  id='phone_number'
                  name='phone_number'
                  type='number'
                />
                <label
                  onClick={() => setFocus('phone_number')}
                  className={cn(
                    { 'label--top': dirtyFields.phone_number }
                  )}>
                  {t.phone_number}*
                </label>
              </div>
              <Error error={errors.phone_number} />
            </div>

            <div className='col-lg-6'>
              <div className='form-styler form-styler__wrapper'>
                <input
                  {...register('address', { required })}
                  id='address'
                  name='address'
                  type='text'
                />
                <label
                  onClick={() => setFocus('address')}
                  className={cn(
                    { 'label--top': dirtyFields.address }
                  )}>
                  {t.address_constructionsite}*
                </label>
              </div>
              <Error error={errors.address} />
            </div>

            <div className='col-lg-6'>
              <div className='form-styler form-styler__wrapper'>
                <input
                  {...register('postcode', { required })}
                  id='postcode'
                  name='postcode'
                  type='text'
                />
                <label
                  onClick={() => setFocus('postcode')}
                  className={cn(
                    { 'label--top': dirtyFields.postcode }
                  )}>
                  {t.postcode}*
                </label>
              </div>
              <Error error={errors.postcode} />
            </div>

            <div className='col-lg-6'>
              <div className='form-styler form-styler__wrapper'>
                <input
                  {...register('contractor_name')}
                  id='contractor_name'
                  name='contractor_name'
                  type='text'
                />
                <label
                  onClick={() => setFocus('contractor_name')}
                  className={cn(
                    { 'label--top': dirtyFields.contractor_name }
                  )}>
                  {t.contractor_name}
                </label>
              </div>
              <Error error={errors.contractor_name} />
            </div>

            <div className='col-12'>
              <div className='form-styler form-styler__wrapper'>
                <textarea
                  {...register('description', { required })}
                  id='description'
                  name='description'
                  type='text'
                />
                <label
                  onClick={() => setFocus('description')}
                  className={cn(
                    { 'label--top': dirtyFields.description }
                  )}>
                  {t.description}*
                </label>
              </div>
              <Error error={errors.description} />
            </div>

            <div className='col-lg-6'>
              <div className='form-styler form-styler__wrapper'>
                <Controller
                  control={control}
                  name='image'
                  defaultValue={null}
                  render={({ field: { value, onChange, ...field } }) => {
                    return (
                    <>
                      <input
                        {...field}
                        onChange={async event => {
                          event.persist()
                          // wait 300ms so that images taken using mobile cameras will be ready before the user submits
                          await new Promise(resolve => setTimeout(resolve, 300))
                          setSelectedFile(event.target.files?.[0]?.name || '')
                          onChange(event.target.files[0])
                        }}
                        type="file"
                        id="image"
                        accept="image/*"
                        className={styles.hiddenFileInput}
                      />
                      <label htmlFor='image' className={styles.customFileLabel}>
                        {selectedFile || t.image}
                      </label>
                    </>
                    )
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <div className='col-12 pl-4 ml-1'>
          {submitting ? (
            <button
              id='edit-submit'
              name='op'
              aria-label='submit'
              type='submit'
              className={cn(
                'button-pink button-pink--smaller'
              )}>
              <FontAwesomeIcon icon={faSpinner} spin />
            </button>
          ) : (
            <button
              id='edit-submit'
              name='op'
              aria-label='submit'
              type='submit'
              className={cn(
                'button-pink button-pink--smaller'
              )}>
              {t.sendIn}
            </button>
          )}
        </div>
      </form>
    </section>
  )
}

export default TearForm
